<div (click)="emitEvent(category)"
     (keyup.enter)="emitEvent(category)"
     class="dropdown-mobile--spacer d-flex flex-row justify-content-between mb-1 py-2 list-group-item-action btn ds-cursor--pointer bg-none"
     tabindex="0">
  <div [class.category-height]="category.url" class="entry--category d-flex flex-row align-items-center"
       data-cy="entry--category">
    <div *ngIf="category.icon" class="entry--category--image me-3">
      <img alt="{{category.translationKey}} image"
           src="assets/images/header/categories/{{category.translationKey}}.svg">
    </div>
    <span class="ds-heading--xs class ds-color--grey-1">
      {{'categories.' + category.translationKey | cxTranslate}}
    </span>
  </div>
  <div *ngIf="category.subCategories" class="d-flex justify-content-center flex-column ds-color--grey-3"
       data-cy="entry--more">
    <em class="ds-icon ds-icon--arrow-right"></em>
  </div>
</div>
